import { createZustandShallowStore } from '@/lib/zustand';
import { HubConnection } from '@microsoft/signalr';
import { SocketEndpoint } from './enum';

export type SocketStoreProps = {
    dictionaryHub: Record<SocketEndpoint, HubConnection | undefined>;
    onlineUser?: number;
    totalAccessTimes?: number;
    notificationInfo: {
        unreadCount?: number;
        items?: any[];
    };
    setDictionaryHub: (
        name: SocketEndpoint,
        value: HubConnection | undefined
    ) => void;
};

/**
 * store lưu các data liên quan đến socket
 */
export const useSocketStore = createZustandShallowStore<SocketStoreProps>(
    (set, get) => ({
        dictionaryHub: {
            [SocketEndpoint.hubs]: undefined,
        },

        onlineUser: undefined,

        totalAccessTimes: undefined,

        notificationInfo: {
            unreadCount: undefined,
            items: undefined,
        },

        setDictionaryHub(name, value) {
            set({ dictionaryHub: { ...get().dictionaryHub, [name]: value } });
        },
    })
);
